import { z } from "zod";

import { positiveNumber } from "../../../utils/zodUtils";
import { commandType } from "./Attributes";

export const Schema = () =>
    z.object({
        type: z.literal(commandType),
        settings: z.object({
            picture_distance: positiveNumber,
        }),
    });
